import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import * as Sentry from '@sentry/angular';

import {environment} from './environments/environment';
import {StromcheckModule} from './app/stromcheck/stromcheck.module';

Sentry.init({
  dsn: 'https://a7befcc059af4783ace2ee1c554c8181@sentry.co2online.de/9',
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true,

  environment: window.location.host.indexOf('-dev') > 0 ? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0,

  // ignore some errors
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured'
  ]
});
Sentry.setTag('page_locale', navigator['browserLanguage'] ?? navigator.language);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(StromcheckModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
